import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "q-mt-lg text-center" }
const _hoisted_2 = { class: "text-h3" }
const _hoisted_3 = { class: "text-body1" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "text-info text-bold"
}
const _hoisted_7 = {
  key: 0,
  class: "text-body1"
}
const _hoisted_8 = { class: "text-weight-bold" }
const _hoisted_9 = ["innerHTML"]

import { i18n } from "src/boot/i18n"
import { useAuthStore } from "src/stores/authStore"
import { useConfigurationStore } from "src/stores/configurationStore"
import { MissingEntityDefinition } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType, ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxEmptyPage',
  props: {
  missingEntity: {
    required: true,
    type: Object as PropType<MissingEntityDefinition>,
  },

  allowHTML: {
    type: Boolean,
    default: false,
  },

  error: {
    type: Boolean,
    default: false,
  },

  iconColor: {
    type: String,
  },

  showWorkspace: {
    type: Boolean,
    default: false,
  },

  verticalCenter: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = i18n.global
const authStore = useAuthStore()
const configurationStore = useConfigurationStore()

const mainDiv = ref()

const paddingTop = computed(() => {
  if (props.verticalCenter) {
    const mainDivHeight = mainDiv.value?.offsetHeight
    return { paddingTop: `calc(45vh -  ${mainDivHeight}px)` }
  } else {
    return null
  }
})

const currentWorkspaceName = computed(() => {
  return authStore.selectedWorkspace?.name || t("sfxEmpty.this_workspace")
})

const textColorClass = computed(() => {
  return {
    "text-error": props.error,
  }
})

const easterEggsEnabled = computed(() => configurationStore.easterEggs)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mainDiv",
    ref: mainDiv,
    class: "column items-center justify-center text-quote-text",
    style: _normalizeStyle(paddingTop.value)
  }, [
    (props.missingEntity?.icon)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: props.missingEntity.icon,
          color: props.iconColor,
          size: "48px"
        }, null, 8, ["name", "color"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(textColorClass.value)
        }, _toDisplayString(props.missingEntity.title), 3)
      ]),
      _createElementVNode("p", _hoisted_3, [
        (__props.allowHTML)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: props.missingEntity.subtitle
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.missingEntity.subtitle), 1)),
        (props.showWorkspace)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(currentWorkspaceName.value), 1))
          : _createCommentVNode("", true)
      ]),
      (props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("sfxEmpty.contact_administrator")), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("sfxEmpty.http_404")), 1)
          ]))
        : _createCommentVNode("", true),
      (easterEggsEnabled.value && props.missingEntity?.quote)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "text-italic text-body1",
            innerHTML: props.missingEntity.quote
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})